"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var _SubjectType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/SubjectType"));

var _ObjectTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/ObjectTypesType"));

var _ObjectRecordAccessors = require("customer-data-objects/record/ObjectRecordAccessors");

var _loggers = require("customer-data-tracking/loggers");

var _MultipleAssociationsSelect = _interopRequireDefault(require("customer-data-communicator/components/associations/MultipleAssociationsSelect"));

var _AssociationsMediator = require("customer-data-communicator/data/associations/AssociationsMediator");

var _EngagementTypesType = _interopRequireDefault(require("crm_ui/engagements/EngagementTypesType"));

var _ScopesContainer = _interopRequireDefault(require("crm_internal/containers/ScopesContainer"));

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _immutable = require("immutable");

var _BETEngagementAssociationsSelects = _interopRequireDefault(require("crm_ui/BET/engagementAssociations/components/BETEngagementAssociationsSelects"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = require("HubStyleTokens/colors");

var _EngagementTypes = require("customer-data-objects/engagement/EngagementTypes");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: 3px;\n  bottom: 33px;\n  box-shadow: 0 1px 24px 0 rgba(0, 0, 0, 0.08);\n  position: absolute;\n  right: 0;\n  visibility: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledDivPopover = _styledComponents.default.div.withConfig({
  displayName: "EngagementAssociationsSelectsV2__StyledDivPopover",
  componentId: "sc-1wwd0uz-0"
})(_templateObject(), _colors.OLAF, _colors.BATTLESHIP, function (props) {
  return props.isVisible ? 'visible' : 'hidden';
});

function getDefaultObjectTypesToAssociate() {
  var objectTypesToAssociate = [_ObjectTypes.CONTACT, _ObjectTypes.COMPANY, _ObjectTypes.DEAL];

  if (_ScopesContainer.default.getContainer().get()['tickets-access']) {
    objectTypesToAssociate.push(_ObjectTypes.TICKET);
  }

  return objectTypesToAssociate;
}

var propTypes = {
  associationsMap: _reactImmutableProptypes.default.map.isRequired,
  engagementType: _EngagementTypesType.default,
  handleRemove: _propTypes.default.func.isRequired,
  handleSelect: _propTypes.default.func.isRequired,
  inTimeline: _propTypes.default.bool,
  objectType: _ObjectTypesType.default,
  subject: _SubjectType.default,
  objectTypesToAssociate: _propTypes.default.arrayOf(_ObjectTypesType.default),
  onAddBETAssociation: _propTypes.default.func,
  onRemoveBETAssociation: _propTypes.default.func,
  onSetBETAssociations: _propTypes.default.func,
  subjectId: _propTypes.default.string,
  BETServiceAssociations: _reactImmutableProptypes.default.list,
  BETPortalAssociations: _reactImmutableProptypes.default.list
};
var defaultProps = {
  objectTypesToAssociate: getDefaultObjectTypesToAssociate(),
  inTimeline: false,
  onAddBETAssociation: _emptyFunction.default,
  onRemoveBETAssociation: _emptyFunction.default,
  onSetBETAssociations: _emptyFunction.default,
  BETServiceAssociations: (0, _immutable.List)(),
  BETPortalAssociations: (0, _immutable.List)()
};

var EngagementAssociationsSelectsV2 =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(EngagementAssociationsSelectsV2, _PureComponent);

  function EngagementAssociationsSelectsV2(props) {
    var _this;

    (0, _classCallCheck2.default)(this, EngagementAssociationsSelectsV2);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(EngagementAssociationsSelectsV2).call(this, props));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      values: [],
      isBETAssociationsPopoverOpen: false
    };
    return _this;
  }

  (0, _createClass2.default)(EngagementAssociationsSelectsV2, [{
    key: "isBET",
    value: function isBET() {
      return _ScopesContainer.default.isScoped('bet-deliverable-service-association-access') || _ScopesContainer.default.isScoped('bet-portal-association-access');
    }
  }, {
    key: "getChannelFromEngagementType",
    value: function getChannelFromEngagementType(activity) {
      var engagementType = this.props.engagementType;
      return engagementType === _EngagementTypes.CALL ? 'outbound call' : activity;
    }
  }, {
    key: "trackAssociationActions",
    value: function trackAssociationActions(action) {
      var _this$props = this.props,
          objectType = _this$props.objectType,
          engagementType = _this$props.engagementType;

      _loggers.CrmLogger.logRecordInteraction(objectType, {
        action: action,
        type: engagementType ? engagementType.toLowerCase() : 'logged activity'
      });

      if (engagementType === 'EMAIL' || engagementType === 'CALL') {
        var activity = engagementType.toLowerCase();

        _loggers.CommunicatorLogger.log('communicatorInteraction', {
          action: action,
          activity: activity,
          channel: this.getChannelFromEngagementType(activity)
        });
      }
    }
  }, {
    key: "handleSelect",
    value: function handleSelect(objectType, subjectId) {
      this.trackAssociationActions('Add association');
      this.props.handleSelect(objectType, subjectId);
    }
  }, {
    key: "handleRemove",
    value: function handleRemove(objectType, subjectId) {
      this.trackAssociationActions('Remove association');
      this.props.handleRemove(objectType, subjectId);
    }
  }, {
    key: "handleToggleModal",
    value: function handleToggleModal() {
      this.setState(function (state) {
        return {
          isBETAssociationsPopoverOpen: !state.isBETAssociationsPopoverOpen
        };
      });
    }
  }, {
    key: "renderBETSelects",
    value: function renderBETSelects() {
      if (!this.isBET()) {
        return null;
      }

      return _react.default.createElement(_BETEngagementAssociationsSelects.default, {
        engagementType: this.props.engagementType,
        inTimeline: this.props.inTimeline,
        objectType: this.props.objectType,
        subjectId: this.props.subjectId,
        subject: this.props.subject,
        onSetBETAssociations: this.props.onSetBETAssociations,
        onAddBETAssociation: this.props.onAddBETAssociation,
        onRemoveBETAssociation: this.props.onRemoveBETAssociation,
        BETAssociatedServiceObjects: this.props.BETServiceAssociations,
        BETAssociatedPortalObjects: this.props.BETPortalAssociations
      });
    }
  }, {
    key: "renderSelects",
    value: function renderSelects() {
      var _this$props2 = this.props,
          objectType = _this$props2.objectType,
          subject = _this$props2.subject,
          associationsMap = _this$props2.associationsMap,
          objectTypesToAssociate = _this$props2.objectTypesToAssociate,
          engagementType = _this$props2.engagementType;
      var subjectId = (0, _ObjectRecordAccessors.getId)(subject);
      return _react.default.createElement("div", null, _react.default.createElement(_MultipleAssociationsSelect.default, {
        className: "p-top-2 p-left-1",
        objectType: objectType,
        subjectId: subjectId && "" + subjectId,
        subject: subject,
        handleSelect: this.handleSelect,
        handleRemove: this.handleRemove,
        values: (0, _AssociationsMediator.convertAssociationsMapToValues)(associationsMap),
        objectTypesToAssociate: objectTypesToAssociate,
        engagementType: engagementType
      }), this.renderBETSelects());
    }
  }, {
    key: "renderAssociationsPopover",
    value: function renderAssociationsPopover() {
      return _react.default.createElement(_react.Fragment, null, _react.default.createElement(_UILink.default, {
        "data-selenium-test-bet": "manage-associations",
        onClick: this.handleToggleModal
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "associations.associationsPopoverLabel"
      }), _react.default.createElement("span", {
        className: "uiDropdown__buttonCaret private-dropdown__caret m-left-1"
      }, _react.default.createElement("span", {
        className: "caret"
      }))), _react.default.createElement(StyledDivPopover, {
        isVisible: this.state.isBETAssociationsPopoverOpen,
        className: "p-all-4"
      }, this.renderSelects()));
    }
  }, {
    key: "render",
    value: function render() {
      if (this.isBET()) {
        return this.renderAssociationsPopover();
      }

      return this.renderSelects();
    }
  }]);
  return EngagementAssociationsSelectsV2;
}(_PureComponent2.default);

EngagementAssociationsSelectsV2.propTypes = propTypes;
EngagementAssociationsSelectsV2.defaultProps = defaultProps;
var _default = EngagementAssociationsSelectsV2;
exports.default = _default;
module.exports = exports.default;